import { render, staticRenderFns } from "./FilterLanguage.vue?vue&type=template&id=21fa2abe&scoped=true&"
import script from "./FilterLanguage.vue?vue&type=script&lang=ts&"
export * from "./FilterLanguage.vue?vue&type=script&lang=ts&"
import style0 from "./FilterLanguage.vue?vue&type=style&index=0&id=21fa2abe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa2abe",
  null
  
)

export default component.exports